import { useCallback } from 'react';

export function useVideoDuration() {
  const getVideoDuration = useCallback((file: File) => {
    return new Promise<number>((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const video = document.createElement('video');

      video.preload = 'metadata';
      video.src = url;

      video.onloadedmetadata = () => {
        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        URL.revokeObjectURL(url);
        resolve(duration);
      };

      video.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Unable to read video duration'));
      };
    });
  }, []);

  return { getVideoDuration };
}
